package one.healthium.tasks.ui

import co.touchlab.kermit.Logger
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.catch
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.debounce
import kotlinx.coroutines.flow.onStart
import kotlinx.coroutines.flow.update
import one.healthium.tasks.domain.DailyTasksRepository
import one.healthium.ui.common.message.UiMessage
import one.healthium.ui.common.message.UiMessageManager
import one.healthium.ui.common.vm.BaseViewModel
import kotlin.time.Duration.Companion.milliseconds

class DailyTasksViewModel(
    private val dailyTasksRepository: DailyTasksRepository
) : BaseViewModel() {

    private val _state = MutableStateFlow(DailyTasksUiState())
    val state = _state.asStateFlow()

    val uiMessage = UiMessageManager()

    init {
        combine(
            dailyTasksRepository.getDailyTasks()
                .debounce(350.milliseconds), // debounce чтобы анимация выполнения таска проигрывалась сразу после закрытия шита
            dailyTasksRepository.getDailyTasksUnread()
        ) { tasks, hasUnread ->
            _state.update { state ->
                state.copy(
                    loading = false,
                    tasks = tasks,
                    hasUnread = hasUnread,
                )
            }
        }
            .onStart {
                _state.update { state -> state.copy(loading = true) }
            }
            .catch {
                Logger.e("failed to fetch daily tasks", it)
                uiMessage.add(UiMessage.throwable(it))
                _state.update { state -> state.copy(loading = false) }
            }
            .launch()
    }

    fun markDailyTasksAsRead() {
        launch {
            try {
                dailyTasksRepository.markDailyTasksAsRead()
            } catch (e: Exception) {
                Logger.e("failed to fetch daily tasks", e)
                uiMessage.add(UiMessage.throwable(e))
            }
        }
    }
}
